<script setup lang="ts">
import { Ckeditor } from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const content = defineModel<string>({ default: '' })

const editorConfig = {
    licenseKey: 'GPL',
    toolbar: {
        removeItems: ['uploadImage']
    }
}
</script>

<template>
    <Ckeditor :editor="ClassicEditor" v-model="content" :config="editorConfig"></Ckeditor>
</template>

<style lang="css">
.ck.ck-balloon-panel.ck-powered-by-balloon {
    display: none !important;
}
</style>